/**
 * Replace Zero with Number.EPSILON
 *
 * @param value - number to be checked
 * @returns value
 */
export function replaceZeroWithEpsilon(value: number): number {
  return value === 0 ? Number.EPSILON : value;
}
